import axios from 'axios';
import { getStoredUser } from '../utils/authStorage';

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
});

axiosInstance.interceptors.request.use(
  config => {
    const user = getStoredUser();
    if (user && user.authToken) {
      config.headers.Authorization = `Bearer ${user.authToken}`;
    }
    config.withCredentials = true;
    return config;
  },
  error => {
    return error;
  },
);
